"use client";

import { useContentfulInspectorMode } from "@scott/contentful/live-preview-init";
import type { InspectorProps } from "../../lib/inspector";
import { HeroSection, type HeroSectionProps } from "./hero-section";

export type HeroSectionInspectorProps = InspectorProps<
  "container" | "eyebrow" | "title" | "subline" | "svg" | "button0" | "button1"
>;

export function HeroSectionPreview(props: Readonly<HeroSectionProps>) {
  const containerInspector = useContentfulInspectorMode({
    entryId: props.sys?.id,
  });

  const eyebrowInspector = useContentfulInspectorMode({
    entryId: props.title?.sys?.id,
    locale: props.title?.sys?.locale,
  });

  const titleInspector = useContentfulInspectorMode({
    entryId: props.title?.sys?.id,
    locale: props.title?.sys?.locale,
  });

  const sublineInspector = useContentfulInspectorMode({
    entryId: props.title?.sys?.id,
    locale: props.title?.sys?.locale,
  });

  const svgInspector = useContentfulInspectorMode({
    entryId: props.svg?.sys?.id,
  });

  const button0Inspector = useContentfulInspectorMode({
    entryId: props.buttons?.[0]?.sys?.id,
  });

  const button1Inspector = useContentfulInspectorMode({
    entryId: props.buttons?.[1]?.sys?.id,
  });

  return (
    <HeroSection
      {...props}
      inspectorProps={{
        container: containerInspector({ fieldId: "internalName" }) ?? undefined,
        eyebrow: eyebrowInspector({ fieldId: "eyebrow" }) ?? undefined,
        title: titleInspector({ fieldId: "headline" }) ?? undefined,
        subline: sublineInspector({ fieldId: "subline" }) ?? undefined,
        svg: svgInspector({ fieldId: "svg" }) ?? undefined,
        button0: button0Inspector({ fieldId: "text" }) ?? undefined,
        button1: button1Inspector({ fieldId: "text" }) ?? undefined,
      }}
    />
  );
}
